// extracted by mini-css-extract-plugin
module.exports = {"elSection":"Section_elSection__3z-YP","cardSection":"Section_cardSection__2ut-0"};